/* eslint-disable no-unused-vars */
// Sum the offsetWidth/offsetHeight of every <li> up to (not including) `li`.
function sumOffsets(item, nodes, li, dimension) {
  let sum = 0;
  const count = nodes.indexOf(li);
  for (let j = 1; j <= count; j++) {
    const el = item.querySelector('li:nth-child(' + j + ')');
    sum += dimension === 'height' ? el.offsetHeight : el.offsetWidth;
  }
  return sum;
}

// Position the moving tab element over the active <li>.
function positionTab(item, moving_div, li, isColumn) {
  const nodes = Array.from(li.closest('ul').children);
  const index = nodes.indexOf(li) + 1;
  const sum = sumOffsets(item, nodes, li, isColumn ? 'height' : 'width');

  if (isColumn) {
    moving_div.style.transform = 'translate3d(0px,' + sum + 'px, 0px)';
    moving_div.style.width = item.querySelector('li:nth-child(' + index + ')').offsetWidth + 'px';
    moving_div.style.height = item.querySelector('li:nth-child(' + (nodes.indexOf(li) + 1) + ')').offsetHeight;
  } else {
    moving_div.style.transform = 'translate3d(' + sum + 'px, 0px, 0px)';
    moving_div.style.width = item.querySelector('li:nth-child(' + index + ')').offsetWidth + 'px';
  }
}

export default function setNavPills() {
  const total = document.querySelectorAll('.nav-pills');

  function createMovingTab(item) {
    const tab = item.querySelector(".nav-link.active").cloneNode();
    tab.innerHTML = "-";
    const moving_div = document.createElement('div');
    moving_div.classList.add('moving-tab', 'position-absolute', 'nav-link');
    moving_div.appendChild(tab);
    item.appendChild(moving_div);
    moving_div.style.padding = '0px';
    moving_div.style.transition = '.5s ease';
    return moving_div;
  }

  function initNavs() {
    total.forEach(function (item) {
      let moving_div = document.createElement('div');
      const first_li = item.querySelector('li:first-child .nav-link');
      const tab = first_li.cloneNode();
      tab.innerHTML = "-";

      moving_div.classList.add('moving-tab', 'position-absolute', 'nav-link');
      moving_div.appendChild(tab);
      item.appendChild(moving_div);

      moving_div.style.padding = '0px';
      moving_div.style.width = item.querySelector('li:nth-child(1)').offsetWidth + 'px';
      moving_div.style.transform = 'translate3d(0px, 0px, 0px)';
      moving_div.style.transition = '.5s ease';

      item.onmouseover = function (event) {
        const target = getEventTarget(event);
        const li = target.closest('li');
        if (li) {
          const nodes = Array.from(li.closest('ul').children);
          const index = nodes.indexOf(li) + 1;
          item.querySelector('li:nth-child(' + index + ') .nav-link').onclick = function () {
            moving_div = item.querySelector('.moving-tab');
            positionTab(item, moving_div, li, item.classList.contains('flex-column'));
          }
        }
      }
    });
  }

  setTimeout(function () {
    initNavs();
  }, 100);

  // Tabs navigation resize
  window.addEventListener('resize', function () {
    total.forEach(function (item) {
      item.querySelector('.moving-tab').remove();
      const moving_div = createMovingTab(item);

      const li = item.querySelector(".nav-link.active").parentElement;

      if (li) {
        positionTab(item, moving_div, li, item.classList.contains('flex-column'));
      }
    });

    if (window.innerWidth < 991) {
      total.forEach(function (item) {
        if (!item.classList.contains('flex-column')) {
          item.classList.remove('flex-row');
          item.classList.add('flex-column', 'on-resize');
          const li = item.querySelector(".nav-link.active").parentElement;
          const nodes = Array.from(li.closest('ul').children);
          const sum = sumOffsets(item, nodes, li, 'height');
          const moving_div = document.querySelector('.moving-tab');
          moving_div.style.width = item.querySelector('li:nth-child(1)').offsetWidth + 'px';
          moving_div.style.transform = 'translate3d(0px,' + sum + 'px, 0px)';
        }
      });
    } else {
      total.forEach(function (item) {
        if (item.classList.contains('on-resize')) {
          item.classList.remove('flex-column', 'on-resize');
          item.classList.add('flex-row');
          const li = item.querySelector(".nav-link.active").parentElement;
          const nodes = Array.from(li.closest('ul').children);
          const index = nodes.indexOf(li) + 1;
          const sum = sumOffsets(item, nodes, li, 'width');
          const moving_div = document.querySelector('.moving-tab');
          moving_div.style.transform = 'translate3d(' + sum + 'px, 0px, 0px)';
          moving_div.style.width = item.querySelector('li:nth-child(' + index + ')').offsetWidth + 'px';
        }
      })
    }
  });

  // Function to remove flex row on mobile devices
  if (window.innerWidth < 991) {
    total.forEach(function (item) {
      if (item.classList.contains('flex-row')) {
        item.classList.remove('flex-row');
        item.classList.add('flex-column', 'on-resize');
      }
    });
  }

  function getEventTarget(e) {
    e = e || window.event;
    return e.target || e.srcElement;
  }
}